/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import Header from '../Components/Header/index';
import Menu from '../Components/Menu/index';
import usePolling from '../Utils/Helpers/pollingHook.js'
import { Outlet } from 'react-router-dom';
import RouteContentFallback from '../Components/RouteContentFallback';

const Layout = ({ userInfo, colors, getTheme, logo }) => {
  usePolling();
  const [menuWidth, setMenuWidth] = useState('15.1vw');
  const [isNavigating, setIsNavigating] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getTheme();
    if (!localStorage.getItem('userInfo')) {
      navigate('/login');
    }
    if (!userInfo?.id) {
      navigate('/login');
    }
  }, [userInfo]);

  return (
    <div
      className="app p-6 global-font-light flex h-full max-h-full min-h-0 min-w-0 flex-col"
      style={{
        background: colors.menuBgHover,
        minHeight: '100%',
        maxHeight: '100%',
      }}
    >
      <div className="shrink-0">
        <Header colors={colors} logo={logo} />
      </div>
      <div className="flex min-h-0 max-h-full min-w-0 flex-1 justify-end items-stretch gap-[1.25%]">
        <div
          style={{
            width: `${menuWidth}`,
          }}
          className="w-max shrink-0"
        >
          <Menu
            colors={colors}
            widthHandler={(data) => {
              setMenuWidth(data);
            }}
          />
        </div>

        <div className="relative flex min-h-0 max-h-full min-w-0 flex-1 flex-col" colors={colors}>
          <React.Suspense fallback={<RouteContentFallback />}>
            <Outlet context={[colors]} />
          </React.Suspense>
        </div>
      </div>
      <footer className="mt-4 shrink-0 text-center text-xs text-gray-600">
        For Feedback or Support questions, please reach out to
        <a
          href="mailto:support@savvydisplays.com"
          style={{ color: colors?.mainColor }}
        >
          {' '}
          support@savvydisplays.com
        </a>
      </footer>
    </div>
  );
};
const mapState = (state) => ({
  colors: state.theme.colors,
  userInfo: state.user.data,
  logo: state.theme.logoo,
});
const mapDispatch = (dispatch) => ({
  getTheme: (data) => dispatch.theme.getTheme(data),
});
export default connect(mapState, mapDispatch)(Layout);
